<script setup>
import { toFixedTwo } from '@/helpers';
import { useAuthStore } from '@/stores/auth';
import { useUsersStore } from '@/stores/users';
import { storeToRefs } from 'pinia';
import { onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()
const startDate = ref(route.query.sd || '')
const endDate = ref(route.query.ed || '')
const currency = ref(route.query.curr || '')
const users = useUsersStore()
const auth = useAuthStore()
const { getCurrency, getUser } = storeToRefs(auth)
const gamesByToday = ref([])

const getGameByToday = async () => {
  const res = await users.fetchGamesByTodayFinance({
    sd: startDate.value,
    ed: endDate.value,
    cuid: currency.value
  })
  gamesByToday.value = res.data.data
}

onMounted(() => {
    if (getUser.value.rl !== 'clt') {
        router.replace({ name: 'finance' })
    } else {
        getGameByToday()
    }
})
</script>

<template>
    <div>
        <div class="udet-Container">
            <div class="flex items-center justify-between">
                <RouterLink class="text-xs text-neutral-600 leading-none" to="/finance">&larr; {{$t('partials.12')}}</RouterLink>
                <h1 class="text-sm font-bold">Games  {{ startDate }}</h1>
            </div>

            <table class="fin-Table mt-2">
            <thead class="">
                <tr>
                    <th class="left">{{$t('partials.39')}}</th>
                    <th>{{$t('partials.2')}}</th>
                    <th>{{$t('partials.40')}}</th>
                    <th>{{$t('partials.41')}}</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="info in gamesByToday">
                    <td class="left">{{ info._id?.gameNm }}</td>
                    <td>{{ toFixedTwo(info.turnover) }}</td>
                    <td>{{ toFixedTwo(info.win) }}</td>
                    <td>{{ toFixedTwo(info.diff) }} {{ getCurrency(currency).cod }}</td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>
</template>
<style scoped>
.udet-Container {
    background-color: #ebeded;
    @apply px-6 py-4  overflow-hidden;
}
.fin-Table {
    @apply w-full text-neutral-900 divide-y divide-neutral-700 bg-neutral-300 rounded-md;
    font-size: 2.5vw;
    line-height: 7vw;
    text-align: right;
}

.fin-Table th,
.fin-Table td {
    @apply px-2
}

.fin-Table th {
    @apply font-normal text-neutral-900;
}

.fin-Table .left {
    @apply text-left;
}
</style>